import { Component, OnInit } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { Branches } from 'src/app/Models/branch';
import { ApiService } from 'src/app/Service/api.service';


@Component({
  selector: 'app-branches',
  templateUrl: './branches.component.html',
  styleUrls: ['./branches.component.css']
})
export class BranchesComponent implements OnInit {
  formTitle = "Manage Branches";
  pageIndex = 1;
  pageSize = 10;
  totalRecords = 1;
  dataList = [];
  loadingRecords = true;
  sortValue: string = "desc";
  sortKey: string = "id";
  searchText: string = "";
  filterQuery: string = "";
  isFilterApplied: string = "default";
   logtext:string = "";
   pageSize2=10

  columns: string[][] =[ ["NAME","Name"],["MANAGER_NAME","Manager Name"],["POST","Post"],["ADDRESS","Address"],["PHONE_NO","Phone no"],["SEQUENCE_NO","Sequence no"]]

  //drawer Variables
  drawerVisible: boolean;
  drawerTitle: string;
  drawerData: Branches = new Branches();
  constructor(private api: ApiService,private message: NzNotificationService) { }
  ngOnInit() {
    this.search();

	this.logtext = 'OPENED - Branches form KEYWORD[O - Branches] ';
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });
  }
  // Basic Methods
  sort(sort: { key: string; value: string }): void {
    this.sortKey = sort.key;
    this.sortValue = sort.value;
    this.search(true);
  }
  search(reset: boolean = false) {
    if (reset) {
      this.pageIndex = 1;
    }
    this.loadingRecords = true;
    var sort: string;
    try {
      sort = this.sortValue.startsWith("a") ? "asc" : "desc";
	
	this.logtext = 'Filter Applied - Branches form"+ sort +" "+this.sortKey +" KEYWORD [F - Branches] ';
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //     });

    } catch (error) {
      sort = "";
    }
    console.log("search text:" + this.searchText);
    if (this.searchText != "") {
      var likeQuery = " AND";
      this.columns.forEach(column => {
        likeQuery += " " + column[0] + " like '%" + this.searchText + "%' OR";
      });
      likeQuery = likeQuery.substring(0, likeQuery.length - 2)
      console.log("likeQuery" + likeQuery);
    }

	this.logtext = 'Filter Applied - Branches form "+ likeQuery +" KEYWORD [F - Branches] ';
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //     });

    this.api.getAllBranches(this.pageIndex, this.pageSize, this.sortKey, sort, likeQuery).subscribe(data => {
      this.loadingRecords = false;
      this.totalRecords = data['count'];
      this.dataList = data['data'];
    }, err => {
      console.log(err);
    });
  }
  //Drawer Methods
  get closeCallback() {
    return this.drawerClose.bind(this);
  }
  add(): void {
    this.drawerTitle = "Create New Branch";
    this.drawerData = new  Branches();
    this.drawerVisible = true;

	this.logtext = 'ADD - Branches form KEYWORD [A - Branches] ';
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //     });

  }
  edit(data:  Branches): void {

    this.drawerTitle = "Update Branch";
    this.drawerData = Object.assign({}, data);
    this.drawerVisible = true;

	this.logtext = 'EDIT - Branches form KEYWORD [E - Branches] ';
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });


  }
  drawerClose(): void {
    this.search();
    this.drawerVisible = false;
  }

  
  publish(): void {

    this.api.publish('branches')
      .subscribe(successCode => {
        if (successCode['code'] == "200") {
          this.message.success("Page Published Successfully", "");
          window.open("http://krishnakoyanapatsanstha.com/branches.html", "_blank");
        }
        else {
          this.message.error("Failed to publish...", "");
        }
      });

  }


  preview(): void {

    this.api.preview('branches')
      .subscribe(successCode => {
        if (successCode['code'] == "200") {
          this.message.success("Page Published Successfully", "");
          window.open("http://krishnakoyanapatsanstha.com/preview/branches.html", "_blank");
        }
        else {
          this.message.error("Failed to publish...", "");
        }
      });

  }
}